const options = document.querySelector(".options")
const dTypes = document.querySelectorAll("#d-type-selector button")
const searchBar = document.getElementById("search-bar")
const tagBar = document.getElementById("tag-bar")
const projectsContainer = document.querySelector(".projects")
const projects = document.querySelectorAll(".project")

// Scroll morphing
window.addEventListener("scroll", () => {
    const currentScrollPos = window.scrollY

    if (currentScrollPos == 0) {
        // Scrolling up, show nav
        options.classList.remove("united")
    } else {
        // Scrolling down or at the top, hide nav
        options.classList.add("united")
    }
})

// Grid display
for (const dType of dTypes) {
    dType.addEventListener("click", () => {
        for (const j of dTypes) {
            j.classList.remove("active")
            projectsContainer.classList.remove(j.id)
        }
        dType.classList.add("active")
        projectsContainer.classList.add(dType.id)
    })
}

// Search engine
const projectObjects = []
const tags = new Set()
for (const project of projects) {
    const tag = project.querySelector(".tags span").textContent
    projectObjects.push({
        title: project.querySelector(".title").textContent,
        tags: tag,
        el: project,
    })
    for (const i of tag.split(", ")) tags.add(i)
}

searchBar.addEventListener("input", () => {
    const value = searchBar.value.toLowerCase()
    for (const project of projectObjects) {
        if (project.title.toLowerCase().includes(value)) {
            project.el.classList.remove("hidden")
        } else {
            project.el.classList.add("hidden")
        }
    }
})

tagBar.innerHTML += `<option>All</option>`
for (const tag of tags) {
    tagBar.innerHTML += `<option>${tag}</option>`
}

tagBar.addEventListener("input", () => {
    const value = tagBar.value.toLowerCase()
    for (const project of projectObjects) {
        if (project.tags.toLowerCase().includes(value) || value == "all") {
            project.el.classList.remove("hidden")
        } else {
            project.el.classList.add("hidden")
        }
    }
})
